import { ICategoryType } from "@wot/typings";
import xhr from "../utils/fetch";

const getCategoriesByType = async (type: ICategoryType) => {
  return await xhr({
    url: `/categories?type=${type}`,
    method: "GET",
  }).then((res) => res.data)
    .catch(err => { throw err })
};

const categoriesApi = {
  getCategoriesByType
}

export default categoriesApi